'use es6';

import PropTypes from 'prop-types';
import { Fragment } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import RouterDropdownFilter, { RouterFilterTags, ClearFiltersLink, StyledTagsContainer } from './RouterDropdownFilter';
import { RouterSelectSingle } from '../../features/filters';
import { FILTER_TYPES } from '../../constants/TopFilterConstants';
import LanguageFilterAlert from '../../components/LanguageFilterAlert/LanguageFilterAlert';
import { useImmutableFilters } from '../../features/filters/filtersQueries';
import { View } from 'foundations-components/components/View';
import { FilterBar } from 'foundations-components/transitional/components/FilterBar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const taggedFilters = [FILTER_TYPES.AWARD_TYPE, FILTER_TYPES.LEVEL, FILTER_TYPES.DURATION, FILTER_TYPES.CONTENT_TYPE, FILTER_TYPES.LANGUAGE];
const TracksTopFiltersContainer = ({
  hideContentType
}) => {
  const {
    filtersLoading
  } = useImmutableFilters();
  return !filtersLoading && /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(FilterBar, {
      marginBlock: "300",
      marginInline: "0",
      startSlot: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.myLearning.filterBy"
        }), /*#__PURE__*/_jsx(RouterDropdownFilter, {
          filterType: FILTER_TYPES.AWARD_TYPE
        }), /*#__PURE__*/_jsx(RouterDropdownFilter, {
          filterType: FILTER_TYPES.LEVEL
        }), /*#__PURE__*/_jsx(RouterDropdownFilter, {
          filterType: FILTER_TYPES.DURATION
        }), !hideContentType && /*#__PURE__*/_jsx(RouterDropdownFilter, {
          filterType: FILTER_TYPES.CONTENT_TYPE
        }), /*#__PURE__*/_jsx(View, {
          as: "span",
          marginInlineStart: "200",
          children: /*#__PURE__*/_jsx(RouterSelectSingle, {
            filterType: FILTER_TYPES.LANGUAGE,
            menuStyles: {
              maxBlockSize: '270px'
            },
            menuWidth: "auto",
            retainSelection: false,
            valueRenderer: () => /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.topFilters.language.filterTitle"
            })
          })
        })]
      })
    }), /*#__PURE__*/_jsxs(StyledTagsContainer, {
      children: [taggedFilters.map(filter => /*#__PURE__*/_jsx(RouterFilterTags, {
        filterType: filter
      }, filter)), /*#__PURE__*/_jsx(ClearFiltersLink, {
        filtersToClear: taggedFilters
      })]
    }), /*#__PURE__*/_jsx(LanguageFilterAlert, {})]
  });
};
TracksTopFiltersContainer.propTypes = {
  hideContentType: PropTypes.bool,
  isRequesting: PropTypes.bool
};
export default TracksTopFiltersContainer;